import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Layout, { PageHeader } from "@/components/Layout";
import { api, fmtINR, fmtNum } from "@/lib/api";
import { Plus, Search } from "lucide-react";

export default function SlottedQuotations() {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");

  useEffect(() => {
    api.get("/slotted/quotations").then((r) => setRows(r.data));
  }, []);

  const filtered = rows.filter((r) => {
    if (!q) return true;
    const hay = [r.quote_number, r.client?.company, r.client?.name, r.created_by_name]
      .filter(Boolean)
      .join(" ")
      .toLowerCase();
    return hay.includes(q.toLowerCase());
  });

  return (
    <Layout>
      <PageHeader
        eyebrow="Slotted Angle · Pipeline"
        title="Slotted Angle Quotations"
        actions={
          <button onClick={() => navigate("/slotted")} className="btn-primary" data-testid="sa-new-quote">
            <Plus size={16} /> New slotted rack
          </button>
        }
      />

      <div className="p-8">
        <div className="panel">
          <div className="flex items-center gap-3 px-5 py-4 border-b border-line">
            <Search size={16} className="text-ink-faint" />
            <input
              value={q}
              onChange={(e) => setQ(e.target.value)}
              className="flex-1 outline-none bg-transparent text-sm"
              placeholder="Search…"
              data-testid="sa-search"
            />
          </div>
          {filtered.length === 0 ? (
            <div className="p-16 text-center text-ink-muted">
              <div className="label-tech">No slotted-angle quotations</div>
            </div>
          ) : (
            <table className="w-full grid-lines">
              <thead>
                <tr>
                  <th>Quote #</th>
                  <th>Client</th>
                  <th>Size (L × D × H)</th>
                  <th className="num">Shelves</th>
                  <th className="num">Weight</th>
                  <th className="num">Grand Total</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((r) => (
                  <tr
                    key={r.id}
                    onClick={() => navigate(`/slotted-quotations/${r.id}`)}
                    className="cursor-pointer hover:bg-surfaceAlt"
                    data-testid={`sa-row-${r.quote_number}`}
                  >
                    <td className="mono font-bold">{r.quote_number}</td>
                    <td>{r.client?.company || r.client?.name || "—"}</td>
                    <td className="mono text-xs">
                      {r.config.length_in}" × {r.config.depth_in}" × {r.config.height_in}"
                    </td>
                    <td className="num">{r.config.shelves}</td>
                    <td className="num">{fmtNum(r.total_weight_kg, 1)} kg</td>
                    <td className="num font-semibold">{fmtINR(r.grand_total_price || r.total_price)}</td>
                    <td>
                      <span className="label-tech">{r.status}</span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </Layout>
  );
}
